import { zodResolver } from "@hookform/resolvers/zod"
import { ValidationMessage } from "@sop/SEEMP/SeempActionCard"
import { IconButton } from "@ui-lib/index"
import { requestApi2 } from "@utils/http"
import { endpoints } from "api"
import { Dispatch, SetStateAction } from "react"
import { useForm } from "react-hook-form"
import { MdClear, MdDelete, MdSave } from "react-icons/md"
import { z } from "zod"
import { NewActionDefinitionForm } from "./NewActionDefinitionComponent"
import { SeempActionDefinition, SeempSchemaConfigFE } from "./types"

const ActionDefinitionForm = NewActionDefinitionForm.extend({
	//isTrendLogicImplemented: z.boolean(),
})
export default function ActionDefinitionCard({
	schemaId,
	actionGroupId,
	actionDefinition,
	setSeempSchemas,
}: {
	schemaId: number
	actionGroupId: number
	actionDefinition: SeempActionDefinition
	setSeempSchemas: Dispatch<SetStateAction<SeempSchemaConfigFE[]>>
}) {
	const {
		register,
		handleSubmit,
		formState: { isDirty, errors },
		control,
		reset,
		setValue,
		watch,
		trigger,
	} = useForm<z.infer<typeof ActionDefinitionForm>>({
		resolver: zodResolver(ActionDefinitionForm),
		defaultValues: {
			type: actionDefinition.type,
			unit: actionDefinition.unit,
			description: actionDefinition.description,
			//yAxisLabel: actionDefinition.yAxisLabel,
			optimization: actionDefinition.optimization,
			//isTrendLogicImplemented: actionDefinition.isTrendLogicImplemented,
		},
		mode: "onChange",
	})

	const description = watch("description")
	const type = watch("type")
	const unit = watch("unit")
	//const yAxisLabel = watch("yAxisLabel")
	const optimization = watch("optimization")
	//const isTrendLogicImplemented = watch("isTrendLogicImplemented")

	const handleActionDefinitionDelete = async (
		schemaId: number,
		actionGroupId: number,
		actionDefinitionId: number
	) => {
		if (!window.confirm("Are you sure you want to delete this action definition?")) {
			return
		}
		try {
			await requestApi2(endpoints.seempDeleteActionDefinition, { id: actionDefinitionId })
			alert("Action definition deleted successfully")
			setSeempSchemas((prev) =>
				prev.map((schema) =>
					schema.id === schemaId
						? {
								...schema,
								actionGroups: schema.actionGroups.map((group) =>
									group.id === actionGroupId
										? {
												...group,
												actionsDefinitions: group.actionsDefinitions.filter(
													(action) => action.id !== actionDefinitionId
												),
											}
										: group
								),
							}
						: schema
				)
			)
		} catch (error) {
			console.error("Error deleting action definition:", error)
			alert("Error deleting action definition")
		}
	}

	const handleActionDefinitionUpdate =
		(schemaId: number, actionGroupId: number, actionDefinitionId: number) => async () => {
			if (type === "" || description === "" || unit === "") {
				alert("Please fill in all fields")
				return
			}
			try {
				await requestApi2(endpoints.seempUpdateActionDefinition, {
					actionDefinitionId,
					type: type === actionDefinition.type ? undefined : type,
					description:
						description === actionDefinition.description ? undefined : description,
					unit: unit === actionDefinition.unit ? undefined : unit,
					//yAxisLabel: yAxisLabel === actionDefinition.yAxisLabel ? undefined : yAxisLabel,
					optimization:
						optimization === actionDefinition.optimization ? undefined : optimization,
					// isTrendLogicImplemented:
					// 	isTrendLogicImplemented === actionDefinition.isTrendLogicImplemented
					// 		? undefined
					// 		: isTrendLogicImplemented,
				})
				alert("Action definition updated successfully")
				setSeempSchemas((prev) =>
					prev.map((schema) =>
						schema.id === schemaId
							? {
									...schema,
									actionGroups: schema.actionGroups.map((group) =>
										group.id === actionGroupId
											? {
													...group,
													actionsDefinitions:
														group.actionsDefinitions.map((action) =>
															action.id === actionDefinitionId
																? {
																		...action,
																		type,
																		description,
																		unit,
																		//yAxisLabel,
																		optimization,
																		//isTrendLogicImplemented,
																	}
																: action
														),
												}
											: group
									),
								}
							: schema
					)
				)
			} catch (error) {
				console.error("Error updating action definition:", error)
				alert("Error updating action definition")
			}
		}

	return (
		<div
			key={actionDefinition.id}
			className={`border-dipai-secondary-901 flex flex-col gap-3 rounded-sm border-1 p-3 pt-0`}
		>
			<div className={`bg-dipai-secondary-200 -mx-3 flex flex-row gap-2 py-1 pr-3 pl-1`}>
				<input
					className={`text-menu focus:border-dipai-secondary-901/50 hover:border-dipai-secondary-901/50 h-8 w-[calc(100%-4rem-1rem)] rounded-sm border-1 px-2 outline-none focus:ring-1 ${errors.type !== undefined ? "border-red-500 hover:border-red-700 focus:ring-red-700" : "hover:border-dipai-secondary-500 focus:ring-dipai-secondary-500 border-transparent"}`}
					id="type"
					{...register("type")}
				/>
				<IconButton
					size={"medium"}
					variant={"outline-dark"}
					onClick={() =>
						handleActionDefinitionDelete(schemaId, actionGroupId, actionDefinition.id)
					}
				>
					<IconButton.Icon>{MdDelete}</IconButton.Icon>
				</IconButton>
				<IconButton
					size={"medium"}
					variant={"outline-dark"}
					disabled={isDirty === false}
					onClick={() => reset()}
				>
					<IconButton.Icon>{MdClear}</IconButton.Icon>
				</IconButton>
				<IconButton
					size={"medium"}
					variant={"outline-dark"}
					disabled={
						(type === actionDefinition.type &&
							description === actionDefinition.description &&
							unit === actionDefinition.unit &&
							//yAxisLabel === actionDefinition.yAxisLabel &&
							optimization === actionDefinition.optimization) ||
						//&&
						//isTrendLogicImplemented === actionDefinition.isTrendLogicImplemented
						type === "" ||
						description === "" ||
						unit === ""
						// || yAxisLabel === ""
					}
					onClick={handleActionDefinitionUpdate(
						schemaId,
						actionGroupId,
						actionDefinition.id
					)}
				>
					<IconButton.Icon>{MdSave}</IconButton.Icon>
				</IconButton>
			</div>
			<div className={`flex flex-col gap-1.5`}>
				<label
					htmlFor={`description_action_${actionDefinition.id}`}
					className={`text-dipai-secondary-901 text-button h-4 leading-[0.875rem]`}
				>
					{"description"}
				</label>
				<input
					className={`h-8 w-full rounded-sm border-1 px-2 outline-none focus:ring-1 ${errors.description !== undefined ? "border-red-500 hover:border-red-700 focus:ring-red-700" : "border-dipai-secondary-901/20 hover:border-dipai-secondary-500 focus:ring-dipai-secondary-500"}`}
					id={`description_action_${actionDefinition.id}`}
					{...register("description")}
				/>
				{errors.description?.message !== undefined ? (
					<ValidationMessage
						type={"error"}
						validationMessage={errors.description.message}
					/>
				) : null}
			</div>
			<div className={`flex w-full gap-3`}>
				<div className={`flex w-36 flex-col gap-1.5`}>
					<label
						htmlFor={`unit_action_${actionDefinition.id}`}
						className={`text-dipai-secondary-901 text-button h-4 leading-[0.875rem]`}
					>
						{"unit"}
					</label>
					<input
						className={`h-8 w-full rounded-sm border-1 px-2 outline-none focus:ring-1 ${errors.unit !== undefined ? "border-red-500 hover:border-red-700 focus:ring-red-700" : "border-dipai-secondary-901/20 hover:border-dipai-secondary-500 focus:ring-dipai-secondary-500"}`}
						id={`unit_action_${actionDefinition.id}`}
						{...register("unit")}
					/>
					{errors.unit?.message !== undefined ? (
						<ValidationMessage
							type={"error"}
							validationMessage={errors.unit.message}
						/>
					) : null}
				</div>
				{/* <div className={`flex w-[calc(100%-27rem-2.25rem)] flex-col gap-1.5`}>
					<label
						htmlFor={`yAxisLabel_action_${actionDefinition.id}`}
						className={`text-dipai-secondary-901 text-button h-4 leading-[0.875rem]`}
					>
						{"y-axis label"}
					</label>
					<input
						className={`h-8 w-full rounded-sm border-1 px-2 outline-none focus:ring-1 ${errors.yAxisLabel !== undefined ? "border-red-500 hover:border-red-700 focus:ring-red-700" : "border-dipai-secondary-901/20 hover:border-dipai-secondary-500 focus:ring-dipai-secondary-500"}`}
						id={`yAxisLabel_action_${actionDefinition.id}`}
						{...register("yAxisLabel")}
					/>
					{errors.yAxisLabel?.message !== undefined ? (
						<ValidationMessage
							type={"error"}
							validationMessage={errors.yAxisLabel.message}
						/>
					) : null}
				</div> */}
				<div className={`flex w-36 flex-col gap-1.5`}>
					<label
						htmlFor={`optimization_action_${actionDefinition.id}`}
						className={`text-dipai-secondary-901 text-button h-4 leading-[0.875rem]`}
					>
						{"goal"}
					</label>
					<select
						className={`h-8 w-full rounded-sm border-1 px-2 py-0 outline-none focus:ring-1 ${errors.optimization !== undefined ? "border-red-500 hover:border-red-700 focus:ring-red-700" : "border-dipai-secondary-901/20 hover:border-dipai-secondary-500 focus:ring-dipai-secondary-500"}`}
						id={`optimization_action_${actionDefinition.id}`}
						{...register("optimization")}
					>
						<option value="minimize">minimize</option>
						<option value="maximize">maximize</option>
					</select>
					{errors.optimization?.message !== undefined ? (
						<ValidationMessage
							type={"error"}
							validationMessage={errors.optimization.message}
						/>
					) : null}
				</div>
			</div>
			<p className={`text-tiny text-dipai-secondary-901/80 leadin-[0.875rem]`}>
				{`created by ${`email_for_user_with_id_${actionDefinition.createdByUserId}`} @ ${actionDefinition.createdAt.toLocaleDateString()}`}
			</p>
		</div>
	)
}
